(function($, bc, undefined) {

	"use strict";

	const RESPONSIVE_SWITCH_MQ = '(max-width: 768px)';

	/**
	 * @class LazyLoads
	 */
	class LazyLoads {

		/**
		 * Creates an instance of LazyLoads
		 */
		constructor() {
			// setup:
			this.setup();
		} /* constructor */

		setup() {

			/* setup lazyloads */
			/* *************** */

			// basic lazy loads:
			this._setupBasicLazyLoads();

			// responsive lazy loads:
			this._setupResponsiveLazyLoads();

		} /* setup */

		_setupBasicLazyLoads() {

			$('.js-lazyload-paragraph-background').lazy({
				removeAttribute: false,
				afterLoad: function(element) {
					$(element).addClass('js-image-lazy-loaded');
				},
			});

		} /* _setupBasicLazyLoads */

		_setupResponsiveLazyLoads() {
			const lazyloads = this;
			if (window.matchMedia) {

				// get the media query:
				const mqIsResponsive = window.matchMedia(RESPONSIVE_SWITCH_MQ);

				// check which data-attribute we should use:
				let attributeToLoad = 'data-src';
				if (mqIsResponsive.matches) {
					attributeToLoad = 'data-src-mobile';
				}
				// -> remove the "data-", for later use:
				const attributeToLoadValue = attributeToLoad.replace(/data-/g, '');

				// setup the lazy loads:
				$('.js-responsive-lazyload-paragraph-background').lazy({
					attribute: attributeToLoad,
					removeAttribute: false,
					afterLoad: function(element) {
						$(element).addClass('js-image-lazy-loaded');
						$(element).attr('data-attribute-loaded', attributeToLoadValue);
					},
				});

				// handle responsive image change:
				mqIsResponsive.addListener(lazyloads._handleResponsiveImageChange);

			}
		} /* _setupResponsiveLazyLoads */

		_handleResponsiveImageChange(mediaQuery) {

			// go through each responsive-lazyload element that has been processed:
			$(document).find('.js-responsive-lazyload-paragraph-background').each(function(index, element) {
				if(element.hasAttribute('data-attribute-loaded')) {
					const $imageElement = $(element);
					const currentlyLoadedAttribute = $imageElement.attr('data-attribute-loaded');

					if(mediaQuery.matches) {
						// -> if we're on responsive, and the "src-mobile" image is not
						//    loaded, we need to load it:
						if(currentlyLoadedAttribute === 'src') {
							const mobileImageUrl = $imageElement.attr('data-src-mobile');
							$imageElement.css('background-image', `url('${mobileImageUrl}')`);
							$imageElement.attr('data-attribute-loaded', 'src-mobile');
						}
					} else {
						// -> if we're on desktop, and the "src" image is not
						//    loaded, we need to load it:
						if(currentlyLoadedAttribute === 'src-mobile') {
							const desktopImageUrl = $imageElement.attr('data-src');
							$imageElement.css('background-image', `url('${desktopImageUrl}')`);
							$imageElement.attr('data-attribute-loaded', 'src');
						}
					}
				}
			});

		}

	} /* LazyLoads */

	bc.LazyLoads = LazyLoads;

})(jQuery, window.bc = window.bc || {});
